module.exports = __webpack_public_path__ + "src/img/xuanti_on.6c98095c.svg";